<div
  id="mach-homepage-footer-social-icons-container"
  data-acdl-page-section="footer:social icons"
  class="flex flex-row items-center p-0 w-24 h-8 flex-none order-0"
>
  <a
    #facebook
    tabindex="0"
    aria-haspopup="true"
    class="inline-block w-14 h-14 mr-8 flex-none cursor-pointer"
    [attr.data-acdl-action]="
      'footer:social icons:' + iconsContent[0]?.iconAlt | lowercase
    "
    [attr.data-acdl-name]="iconsContent[0]?.iconAlt | lowercase"
    id="mach-homepage-footer-social-icons-facebook"
    (click)="onIconClick(iconsContent[0]); analyticsEvent.emit(facebook)"
  >
    <img
      [src]="iconsContent[0]?.iconLogo"
      [alt]="iconsContent[0]?.iconAlt"
      class="w-full h-full"
    />
  </a>

  <a
    #twitter
    tabindex="0"
    aria-haspopup="true"
    class="inline-block w-14 h-14 flex-none cursor-pointer"
    [attr.data-acdl-action]="
      'footer:social icons:' + identifyIcon(iconsContent[1]?.iconAlt)
    "
    [attr.data-acdl-name]="identifyIcon(iconsContent[1]?.iconAlt)"
    id="mach-homepage-footer-social-icons-twitter"
    (click)="onIconClick(iconsContent[1]); analyticsEvent.emit(twitter)"
  >
    <img
      [src]="iconsContent[1]?.iconLogo"
      [alt]="iconsContent[1]?.iconAlt"
      class="w-full h-full"
    />
  </a>
</div>
